import areaCoverage from './area-coverage.js';
import geocoder from './geocoder.js';
import map from './map.js';
import search from './search/index.js';
import selections from './selections.js';
import settings from './settings.js';
import wizard from './wizard.js';
import {combineReducers} from '@reduxjs/toolkit';

const reducer = combineReducers({
  areaCoverage,
  geocoder,
  map,
  search,
  selections,
  settings,
  wizard,
});

export default reducer;
